import {useState} from 'react'
import './Display.styles.css'

type DisplayProperties = {
    foods: any
    selected: string
    setSelected: (name: string) => void
    deleteFoodItem: (name: string) => void
}

function Display({foods, selected, setSelected, deleteFoodItem}: DisplayProperties) {
    const [items] = useState(foods)

    function selectItem(name: string) {
        if (selected === name)
            setSelected('')
        else setSelected(name)
    }

    return (
        <div>
            {Object.entries(items).map(
                ([name, attributes]) =>
                    <div key={name}>
                        <div
                            className={selected === name ? 'row' : '_row'}
                            onClick={() => selectItem(name)}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '40px',
                                margin: '10px auto',
                                maxWidth: '400px',
                                gap: '20px'
                            }}>

                            <h3>{name}</h3>

                            <button className={'close-button'} onClick={() => deleteFoodItem(name)}>
                                ✔
                            </button>
                        </div>

                        {selected === name &&
                            <div className={'popup-overlay'} onClick={() => setSelected('')}>
                                <div className={'popup-content'} onClick={(e) => e.stopPropagation()}>
                                    <h1>{name}</h1>
                                    <img src={`/assets/${name}.png`} alt={name}/>

                                    <div style={{
                                        display: 'grid',
                                        gap: '5px',
                                        gridTemplateColumns: `repeat(${Math.round(Math.sqrt(Object.entries(Object(attributes)).length))}, 1fr)`
                                    }}>
                                        {Object.entries(Object(attributes))
                                            .map(([attribute, description]) => (
                                                <div key={attribute}>
                                                    <h2>
                                                        <b>{attribute}:</b> {String(description)}
                                                    </h2>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
            )}
        </div>
    )
}

export default Display